import { render, staticRenderFns } from "./SmallTable.vue?vue&type=template&id=3ba6c3ae&scoped=true"
import script from "./SmallTable.vue?vue&type=script&lang=js"
export * from "./SmallTable.vue?vue&type=script&lang=js"
import style0 from "./SmallTable.vue?vue&type=style&index=0&id=3ba6c3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba6c3ae",
  null
  
)

export default component.exports